export var ClaimEstimatorTimelineLabel;
(function (ClaimEstimatorTimelineLabel) {
    ClaimEstimatorTimelineLabel["customerContactedEmail"] = "Customer Contacted Email";
    ClaimEstimatorTimelineLabel["customerContactedLvm"] = "Customer Contacted Lvm";
    ClaimEstimatorTimelineLabel["customerNoContact"] = "Customer No Contact";
    ClaimEstimatorTimelineLabel["fieldAdjusterContactedCustomer"] = "Estimator Contacted Customer";
    ClaimEstimatorTimelineLabel["fieldAdjusterCorrectionUploaded"] = "Estimator Correction Uploaded";
    ClaimEstimatorTimelineLabel["fieldAdjusterEstimateUploaded"] = "Estimator Estimate Uploaded";
    ClaimEstimatorTimelineLabel["inspectionCompleted"] = "Inspection Completed";
    ClaimEstimatorTimelineLabel["inspectionScheduled"] = "Inspection Scheduled";
    ClaimEstimatorTimelineLabel["inspectionScheduleConfirmed"] = "Scheduled Inspection Confirmed";
    ClaimEstimatorTimelineLabel["invalidContactInformation"] = "Invalid Contact Information";
    ClaimEstimatorTimelineLabel["legalRepAssignedToClaim"] = "Legal Representative Assigned";
    ClaimEstimatorTimelineLabel["legalRepUnassignedFromClaim"] = "Legal Representative Unassigned";
    ClaimEstimatorTimelineLabel["policyHolderAssignedToClaim"] = "Policyholder Assigned";
    ClaimEstimatorTimelineLabel["policyHolderUnassignedFromClaim"] = "Policyholder Unassigned";
    ClaimEstimatorTimelineLabel["primaryContactAssignedToClaim"] = "Primary Contact Assigned";
    ClaimEstimatorTimelineLabel["primaryContactUnassignedFromClaim"] = "Primary Contact Unassigned";
    ClaimEstimatorTimelineLabel["surveySentToCustomer"] = "Survey Sent to Customer";
})(ClaimEstimatorTimelineLabel || (ClaimEstimatorTimelineLabel = {}));
export const claimEstimatorChronicleLabelMap = {
    customerContactedEmail: ClaimEstimatorTimelineLabel.customerContactedEmail,
    customerContactedLvm: ClaimEstimatorTimelineLabel.customerContactedLvm,
    customerNoContact: ClaimEstimatorTimelineLabel.customerNoContact,
    fieldAdjusterContactedCustomer: ClaimEstimatorTimelineLabel.fieldAdjusterContactedCustomer,
    fieldAdjusterCorrectionUploaded: ClaimEstimatorTimelineLabel.fieldAdjusterCorrectionUploaded,
    fieldAdjusterEstimateUploaded: ClaimEstimatorTimelineLabel.fieldAdjusterEstimateUploaded,
    inspectionCompleted: ClaimEstimatorTimelineLabel.inspectionCompleted,
    inspectionScheduled: ClaimEstimatorTimelineLabel.inspectionScheduled,
    inspectionScheduleConfirmed: ClaimEstimatorTimelineLabel.inspectionScheduleConfirmed,
    invalidContactInformation: ClaimEstimatorTimelineLabel.invalidContactInformation,
    legalRepAssignedToClaim: ClaimEstimatorTimelineLabel.legalRepAssignedToClaim,
    legalRepUnassignedFromClaim: ClaimEstimatorTimelineLabel.legalRepUnassignedFromClaim,
    policyHolderAssignedToClaim: ClaimEstimatorTimelineLabel.policyHolderAssignedToClaim,
    policyHolderUnassignedFromClaim: ClaimEstimatorTimelineLabel.policyHolderUnassignedFromClaim,
    primaryContactAssignedToClaim: ClaimEstimatorTimelineLabel.primaryContactAssignedToClaim,
    primaryContactUnassignedFromClaim: ClaimEstimatorTimelineLabel.primaryContactUnassignedFromClaim,
    surveySentToCustomer: ClaimEstimatorTimelineLabel.surveySentToCustomer,
};
